import type { ToolRegistryItem } from '@/lib/tools-registry';

export type ToolsVisibilityCapabilities = {
  canUseTools: boolean;
  canUseImmix: boolean;
  canUseZoomLookup: boolean;
  canEditSettings: boolean;
  canViewServerAdmin?: boolean;
  canOperateServerAdmin?: boolean;
  canViewValidation?: boolean;
};

/** Mirrors Tools admin page tool visibility rules. */
export function isToolVisibleForUser(
  tool: ToolRegistryItem,
  capabilities: ToolsVisibilityCapabilities,
): boolean {
  if (tool.category === 'immix') return capabilities.canUseImmix;
  if (
    tool.id === 'site-check'
    || tool.id === 'device-ip'
    || tool.id === 'alarm-anomalies'
    || tool.id === 'ecare-heartbeat'
  ) {
    return capabilities.canUseImmix;
  }
  if (tool.id === 'zoom-call-lookup') return capabilities.canUseZoomLookup;
  if (tool.id === 'database-backups') {
    return Boolean(capabilities.canViewServerAdmin);
  }
  if (tool.id === 'configuration-validation') {
    return Boolean(capabilities.canUseTools && capabilities.canViewValidation);
  }
  return capabilities.canUseTools;
}
